var React = require('react');

function S14 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_48503","data-name":"Rectangle 48503","width":"28","height":"28","fill":"none","key":0}),React.createElement("path",{"id":"Path_106577","data-name":"Path 106577","d":"M15.077,11.189V4.215A1.651,1.651,0,0,0,13.423,2.56H11.768a1.651,1.651,0,0,0-1.655,1.655V11.2c-1.3.9-4.964,4.124-4.964,12.027a.826.826,0,0,0,.827.827H19.2a.826.826,0,0,0,.827-.827c0-7.929-3.653-11.136-4.964-12.027ZM11.768,4.215h1.655v6.618H11.768V4.215ZM6.817,22.4c.242-6.924,3.564-9.431,4.34-9.915h.6v4.964l-.827,3.309h3.309l-.827-3.309h0V12.487h.611c.776.484,4.1,2.965,4.34,9.915H6.817Z","transform":"translate(1.405 0.698)","key":1})]);
}

S14.defaultProps = {"id":"s-15","width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = S14;

S14.default = S14;
